// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31r2r","col":"styles_col__3MLWf"};